__turbopack_context__.v({
  "button": "stylizedButton-module-scss-module__PszKDG__button",
  "cancel": "stylizedButton-module-scss-module__PszKDG__cancel",
  "large": "stylizedButton-module-scss-module__PszKDG__large",
  "link": "stylizedButton-module-scss-module__PszKDG__link",
  "loading": "stylizedButton-module-scss-module__PszKDG__loading",
  "medium": "stylizedButton-module-scss-module__PszKDG__medium",
  "mini": "stylizedButton-module-scss-module__PszKDG__mini",
  "neutral": "stylizedButton-module-scss-module__PszKDG__neutral",
  "primary": "stylizedButton-module-scss-module__PszKDG__primary",
  "secondary": "stylizedButton-module-scss-module__PszKDG__secondary",
  "small": "stylizedButton-module-scss-module__PszKDG__small",
  "tertiary": "stylizedButton-module-scss-module__PszKDG__tertiary",
  "textonly": "stylizedButton-module-scss-module__PszKDG__textonly",
});
